<template>
    <g>
        <transition name="fade">
            <g>
                <g transform="translate(670, -490)">
                    <logoutButton />
                </g>

                <g
                    v-if="
                        done_rspan != 0 && done_spatial != 0 && done_digits != 0
                    "
                >
                    <text
                        x="0"
                        y="-10"
                        class="txt"
                        text-anchor="middle"
                        dominant-baseline="middle"
                        font-family="sans-serif"
                        font-size="50"
                        fill="#000000"
                        >{{ "Tack! Nu är alla uppgifter klara." }}</text
                    >
                </g>
            </g>
        </transition>
    </g>
</template>

<script>
//              <g
//                  transform="translate(-150, 150)"
//                  v-on:click="this.click_ospan"
//              >
//                  <operationSpanIcon />
//              </g>
//              <g
//                  transform="translate(-150, -150)"
//                  v-on:click="this.click_span_spatial_linear"
//              >
//                  <spatialSpanIcon />
//              <g
//                  transform="translate(150, -150)"
//                  v-on:click="this.click_span_digits"
//              >
//                  <digitsUpdatingIcon />
//              </g>
//
//                  transform="translate(150, 150)"
//                  v-on:click="this.click_rspan"
//              >
//                  <readingSpanIcon />
//              </g>

import { store } from "@/store.js";
import lang from "@/v/licr35/home/lang.js";
//import persist from "@/persist.js";

//import operationSpanIcon from "@/v/taskMenu/icons/operation_span_icon.vue";
//import span_complex_b_icon from "@/v/taskMenu/icons/span_complex_b_icon.vue";
//import readingSpanIcon from "@/v/taskMenu/icons/reading_span_icon.vue";
//import spatialSpanIcon from "@/v/taskMenu/icons/spatialSpanIcon.vue";
//import digitsUpdatingIcon from "@/v/taskMenu/icons/digitsUpdatingIcon.vue";

import logoutButton from "@/v/taskMenu/logoutButton.vue";
import { closeFullscreen } from "@/fullscreen.js";
//import persist from "@/persist.js";

export default {
    name: "menu_licr35",
    components: {
        //operationSpanIcon,
        //readingSpanIcon,
        //spatialSpanIcon,
        //digitsUpdatingIcon,
        logoutButton,
    },
    mixins: [lang],
    computed: {
        text() {
            return this.getLocalisedText();
        },
        done_rspan() {
            return this.$store.state.progress.verbal || 0;
        },
        done_spatial() {
            return this.$store.state.progress.spatial || 0;
        },
        done_digits() {
            return this.$store.state.progress.digits || 0;
        },
    },
    data: () => {
        return {};
    },
    methods: {
        //click_rspan() {
        //  store.dispatch("gotoModule", "test_operation_span_verbal");
        //},
        //      click_ospan() {
        //          store.dispatch("gotoModule", "test_operation_span_math");
        //      },
        //click_span_spatial_linear() {
        //  store.dispatch("gotoModule", "test_span_spatial_linear");
        //},
        //click_span_digits() {
        //  store.dispatch("gotoModule", "test_span_digits");
        //},
    },
    mounted() {
        const done_rspan = this.$store.state.progress.verbal || 0;
        //const done_ospan = this.$store.state.progress.ospan || 0;
        const done_spatial = this.$store.state.progress.spatial || 0;
        const done_digits = this.$store.state.progress.digits || 0;

        if (done_rspan != 1) {
            store.dispatch("gotoModule", "test_operation_span_verbal");
            return;
        }
        //if (done_ospan != 1) {
        //  store.dispatch("gotoModule", "test_operation_span_math");
        //  return;
        //}
        if (done_spatial != 1) {
            store.dispatch("gotoModule", "test_span_spatial_linear");
            return;
        }
        if (done_digits != 1) {
            store.dispatch("gotoModule", "test_span_digits");
            return;
        }

        // All tasks done: the template thanks the participant, who is free to close the tab.
        closeFullscreen();
    },
};
</script>
